import { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import QRCode from 'qrcode';
import { TopBar, Notice } from '../components/ui';

type Done = { slug: string; shop_name: string; staff_pin: string; founding: boolean; trial_ends_at: string | null; shop_url: string; subscribe_url: string };

/** The ah-ha screen: the shop exists. The owner sees their own QR, their barber's PIN (once), and three concrete next actions. */
export default function StartDone() {
  const [sp] = useSearchParams();
  const slug = sp.get('shop') ?? '';
  const d = useMemo<Done | null>(() => { try { const v = JSON.parse(sessionStorage.getItem('tempo_start_done') ?? 'null') as Done | null; return v && v.slug === slug ? v : null; } catch { return null; } }, [slug]);
  const [qr, setQr] = useState('');
  const subscribeUrl = `${location.origin}/s/${slug}`;
  useEffect(() => { QRCode.toDataURL(subscribeUrl, { margin: 1, width: 320, color: { dark: '#000000', light: '#FFFFFF' } }).then(setQr); }, [subscribeUrl]);
  return (
    <main className="min-h-dvh pb-16">
      <TopBar />
      <div className="container max-w-2xl grid gap-5">
        {sp.get('paid') && <Notice kind="ok">تم الدفع. شكرًا لك.</Notice>}
        <section className="rounded-[var(--radius-lg)] bg-accent text-ink p-6 grid gap-2">
          <div className="eyebrow">جاهز</div>
          <h1 style={{ fontSize: '1.9rem' }}>{d ? `محل «${d.shop_name}» صار على تيمبو.` : 'محلك صار على تيمبو.'}</h1>
          <p className="text-sm">هذا رمزك. كل زبون يمسحه يحجز عضويته ويدفع لك عند الكرسي. باقاتك المقترحة جاهزة، وتعدّلها من لوحتك.</p>
        </section>
        <div className="grid md:grid-cols-2 gap-5">
          <section className="card p-5 text-center grid gap-3 place-items-center">
            {qr && <img src={qr} alt="رمز الاشتراك" width={220} height={220} className="rounded-md border border-line" />}
            <div className="text-sm num break-all" dir="ltr">{subscribeUrl}</div>
            <a className="btn btn-ghost" href={`/print/${slug}`} target="_blank" rel="noreferrer">اطبع لوحتك (A5)</a>
          </section>
          <section className="card p-5 grid gap-3">
            <h3>رموز الدخول</h3>
            <div className="text-sm">رمز المالك: الذي اخترته الآن. يفتح كل شيء.</div>
            {d ? <div className="rounded-[var(--radius-md)] bg-paper-2 p-3"><div className="text-sm">رمز الحلاق (يفتح تسجيل الزيارات واستلام الدفع فقط)</div><div className="display num" style={{ fontSize: '2rem' }}>{d.staff_pin}</div><div className="muted text-xs">يظهر مرة واحدة هنا. تغيّره متى شئت من لوحتك.</div></div> : <div className="muted text-sm">رمز الحلاق تجده في لوحتك (زر «رمز الحلاق»).</div>}
            {d?.founding ? <Notice kind="ok">مقعد شريك تأسيس: بلا رسوم حتى {d.trial_ends_at?.slice(0, 10)}.</Notice> : d?.trial_ends_at ? <Notice kind="info">بلا رسوم حتى {d.trial_ends_at.slice(0, 10)}، ثم فاتورتك الأولى على واتساب.</Notice> : null}
          </section>
        </div>
        <section className="card p-5 grid gap-3">
          <h3>ثلاث خطوات تبدأ بها اليوم</h3>
          <ol className="grid gap-2 text-sm list-decimal ps-5">
            <li><b>راجع باقاتك</b>: الأسعار مقترحة من سعر حلاقتك. عدّلها أو اصنع باقة جديدة بالحاسبة.</li>
            <li><b>اطبع اللوحة</b> وعلّقها عند الكاونتر أو المرآة.</li>
            <li><b>أصدر أول بطاقة</b> لزبون قديم بثقة، وشف كيف تصله على واتساب.</li>
          </ol>
          <Link to={`/shop/${slug}?welcome=1`} className="btn btn-primary btn-lg">افتح لوحة محلك</Link>
        </section>
      </div>
    </main>
  );
}
